import SmruLeadForm from "./SmruLeadForm";
import { usePartnerTab } from "./usePartnerTab";

export default function SmruGuidancePage() {
    usePartnerTab("Get Guidance — AI.Prof × SMRU");

    return (
        <SmruLeadForm
            variant="guidance"
            eyebrow="Free Career Guidance"
            title="Your AI Career Starts Here 🚀"
            subtitle="Share a few details and our admissions team will map your path into India's first AI-powered B.Tech."
            submitLabel="Connect with our best team"
        />
    );
}
